import React, { Fragment } from 'react';
var CollapsibleHeader = function (props) {
    return React.createElement(Fragment, null, props.children);
};
export default CollapsibleHeader;
